import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useDispatch } from 'react-redux';
import { setOnlineUser } from '../features/user/userSlice';
import { getLocalStorageData } from '../shared/commonFunction';

let sharedSocketInstance = null;
let sharedSocketBaseUrl = null;

const getOrCreateSharedSocket = (baseUrl, token) => {
    if (sharedSocketInstance && sharedSocketBaseUrl === baseUrl) {
        return sharedSocketInstance;
    }

    sharedSocketBaseUrl = baseUrl;
    sharedSocketInstance = io(baseUrl, {
        transports: ['websocket'],
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        auth: { token },
        // path: '/api/socket.io',
    });

    return sharedSocketInstance;
};

const useSocket = () => {
    const socketRef = useRef(null);
    // ✅ FIX: socket ko state mein track karo, ref return mat karo.
    // socketRef.current return karna non-reactive hai — React changes track
    // nahi karta, isliye consuming component ke useEffect deps stale rehte hain.
    const [socket, setSocket] = useState(null);
    const [isReady, setIsReady] = useState(false);

    const BASE_URL = import.meta.env.VITE_CHAT_BASE_URL;
    const dispatch = useDispatch();

    useEffect(() => {
        const token = getLocalStorageData('token');
        const socketInstance = getOrCreateSharedSocket(BASE_URL, token);

        socketRef.current = socketInstance;

        if (socketInstance.connected) {
            setIsReady(true);
            setSocket(socketInstance);
        } else {
            setIsReady(false);
            setSocket(null);
        }

        const handleConnect = () => {
            console.log('Connected:', socketInstance.id);
            setIsReady(true);
            // ✅ Socket sirf connect hone ke baad expose karo —
            // consuming effects tab chalenge jab socket actually usable ho.
            setSocket(socketInstance);
        };

        const handleDisconnect = (reason) => {
            console.log('Disconnected:', reason);
            setIsReady(false);
            setSocket(null); // ✅ Disconnect pe null karo taaki stale socket use na ho
        };

        const handleReconnect = () => {
            console.log('Reconnected:', socketInstance.id);
            setIsReady(true);
            setSocket(socketInstance);
        };

        const handleConnectError = (error) => {
            console.error('Connection Error:', error);
            setIsReady(false);
        };

        const handleOnlineUser = (data) => {
            dispatch(setOnlineUser(data));
        };

        socketInstance.on('connect', handleConnect);
        socketInstance.on('disconnect', handleDisconnect);
        socketInstance.on('reconnect', handleReconnect);
        socketInstance.on('connect_error', handleConnectError);
        socketInstance.on('onlineUser', handleOnlineUser);

        return () => {
            socketInstance.off('connect', handleConnect);
            socketInstance.off('disconnect', handleDisconnect);
            socketInstance.off('reconnect', handleReconnect);
            socketInstance.off('connect_error', handleConnectError);
            socketInstance.off('onlineUser', handleOnlineUser);
        };
    }, [BASE_URL, dispatch]);

    // socketRef bhi expose karo — direct access ke liye (event emit outside effects)
    return { socket, socketRef, isReady };
};

export default useSocket;